import { Fragment } from "react";
import { Transition } from "@headlessui/react";

const MegaMenuPanel = ({
  isOpen,
  handleClose,
  eyebrow,
  title,
  footer,
  children,
  maxWidth = 960,
  topOffset = 0,
  closeButtonClassName = "border border-hire-line bg-white text-primary hover:border-primary hover:bg-primary hover:text-white",
  upperSpaceClassName = "pb-6 pt-10 px-8  sm:px-10 ",
  titleClassName = "mt-1.5 text-2xl sm:text-3xl",
  childrenClassName = "px-8 sm:px-10",
}) => {
  return (
    <Transition
      as={Fragment}
      show={isOpen}
      enter="transition ease-out duration-150"
      enterFrom="opacity-0 -translate-y-2"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 -translate-y-2"
    >
      <div
        className="fixed inset-x-0 z-20 px-4 pb-6 pt-4 sm:px-6"
        style={{ top: topOffset }}
      >
        <button
          type="button"
          onClick={handleClose}
          aria-label="Close menu overlay"
          className="fixed inset-x-0 bottom-0 -z-10 cursor-default bg-[#070b29]/30 backdrop-blur-sm"
          style={{ top: topOffset }}
        />
        <div
          className="relative mx-auto w-full overflow-hidden rounded-3xl border border-hire-line bg-white font-poppins"
          style={{
            maxWidth,
            borderTop: "5px solid var(--color-secondary)",
            boxShadow: "0 38px 100px rgba(11,17,59,0.28)",
            maxHeight: "calc(100vh - 140px)",
            // overflowY: "auto",
          }}
        >
          <div
            className={`flex items-start justify-between gap-6 border-b border-hire-line  ${upperSpaceClassName}`}
          >
            <div>
              {eyebrow && (
                <p className="font-poppins text-sm font-extrabold tracking-[0.1em] text-[#8e5e00]">
                  {eyebrow}
                </p>
              )}
              <h2
                className={`max-w-2xl font-poppins font-bold leading-tight text-primary ${titleClassName}`}
              >
                {title}
              </h2>
            </div>
            <button
              type="button"
              onClick={handleClose}
              aria-label="Close menu"
              className={`grid h-11 w-11 flex-none place-items-center rounded-full transition-colors ${closeButtonClassName}`}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M2 2L16 16M16 2L2 16"
                  stroke="currentColor"
                  strokeWidth="2.75"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>

          <div className={`py-3 ${childrenClassName}`}>{children}</div>

          {footer && (
            <div className="flex flex-col items-center justify-between gap-4 bg-hire-tint-blue px-8 py-5 sm:flex-row sm:px-10">
              {footer}
            </div>
          )}
        </div>
      </div>
    </Transition>
  );
};

export default MegaMenuPanel;
